import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Lock, Truck, CreditCard, RefreshCw } from 'lucide-react';
export function ProductOffer() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  const includes = ['12 Patrones de Razas (Perros y Gatos)', 'Guía de Personalización de Manchas y Colores', 'Instrucciones paso a paso con fotos', 'Lista de materiales y proveedores recomendados', 'Soporte por email para tus dudas', 'Actualizaciones futuras incluidas'];
  return <section id="producto" className="py-16 md:py-24 bg-linen" data-id="element-214">
      <div className="max-w-4xl mx-auto px-4" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-216">
          <p className="text-sm font-bold tracking-[0.2em] text-warm-brown uppercase mb-4" data-id="element-217">
            Tu colección te espera
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-218">
            Todo lo que necesitas en un solo ebook
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="etsy-card overflow-hidden" data-id="element-219">
          <div className="flex flex-col md:flex-row" data-id="element-220">
            {/* Product Image / Mockup */}
            <div className="md:w-2/5 bg-cream p-8 flex items-center justify-center" data-id="element-221">
              <div className="w-full aspect-[3/4] bg-white rounded-lg shadow-md border border-gray-100 flex flex-col overflow-hidden" data-id="element-222">
                <div className="h-2/3 bg-warm-beige flex items-center justify-center relative" data-id="element-223">
                  <span className="text-warm-brown/40 font-heading text-lg" data-id="element-224">
                    Portada Ebook
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-br from-soft-rose/10 to-transparent" data-id="element-225" />
                </div>
                <div className="h-1/3 p-4 flex flex-col justify-center" data-id="element-226">
                  <div className="h-2 w-3/4 bg-gray-200 rounded mb-2" data-id="element-227" />
                  <div className="h-2 w-1/2 bg-gray-100 rounded mb-2" data-id="element-228" />
                  <div className="h-1.5 w-full bg-gray-50 rounded" data-id="element-229" />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="md:w-3/5 p-8 md:p-10" data-id="element-230">
              <h3 className="text-2xl font-heading font-bold text-deep-brown mb-2" data-id="element-231">
                Colección Mascotas en Crochet
              </h3>
              <p className="text-gray-500 mb-6 text-sm" data-id="element-232">
                Ebook digital · PDF descargable · Acceso inmediato
              </p>

              <ul className="space-y-3 mb-8" data-id="element-233">
                {includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-600" data-id="element-234">
                    <Check size={16} className="text-soft-sage mt-0.5 flex-shrink-0" data-id="element-235" />
                    {item}
                  </li>)}
              </ul>

              <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full py-4 bg-deep-brown text-white rounded-full font-bold text-lg shadow-md hover:shadow-lg hover:bg-warm-brown transition-all duration-300 block text-center mb-5" data-id="element-236">
                Quiero Mi Ebook Ahora
              </a>

              {/* Trust Badges */}
              <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-400 mb-6" data-id="element-237">
                <span className="flex items-center gap-1.5" data-id="element-238">
                  <Lock size={13} data-id="element-239" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-240">
                  <Truck size={13} data-id="element-241" /> Entrega Inmediata
                </span>
                <span className="flex items-center gap-1.5" data-id="element-242">
                  <Shield size={13} data-id="element-243" /> Garantía 7 días
                </span>
              </div>

              {/* Payment Methods */}
              <div className="border-t border-gray-100 pt-5" data-id="element-244">
                <p className="text-xs text-gray-400 text-center mb-3" data-id="element-245">
                  Métodos de pago aceptados
                </p>
                <div className="flex justify-center gap-3 flex-wrap" data-id="element-246">
                  {['Visa', 'Mastercard', 'PayPal', 'Amex'].map(method => <span key={method} className="px-3 py-1.5 bg-gray-50 rounded-md text-xs font-medium text-gray-500 border border-gray-100" data-id="element-247">
                      {method}
                    </span>)}
                </div>
              </div>
            </div>
          </div>

          {/* Guarantee Banner */}
          <div className="bg-cream border-t border-gray-100 p-5 flex items-center justify-center gap-3" data-id="element-248">
            <RefreshCw size={18} className="text-soft-sage" data-id="element-249" />
            <p className="text-sm text-gray-600" data-id="element-250">
              <span className="font-bold text-deep-brown" data-id="element-251">
                Garantía de satisfacción de 7 días.
              </span>{' '}
              Si no es lo que esperabas, te devolvemos tu dinero. Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}